import { render, staticRenderFns } from "./layout-header.vue?vue&type=template&id=6bef9526&scoped=true"
import script from "./layout-header.vue?vue&type=script&lang=ts"
export * from "./layout-header.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bef9526",
  null
  
)

export default component.exports